import { render, staticRenderFns } from "./remover.vue?vue&type=template&id=4069398f&lang=pug&"
import script from "./remover.vue?vue&type=script&lang=js&"
export * from "./remover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports